import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";

const CategoryManager = {
  // Get all categories
  async getAllCategories() {
    const response = await axiosInstance.get(`categories/get`);
    // Assuming your API returns an object like:
    // { responseCode: 200, errorCode: null, responseMessage: "...", responseData: [...] }
    return response.data;
  },

  // Get single category by ID
  async getCategoryById(id) {
    const response = await axiosInstance.get(`categories/get/${id}`);
    return response.data;
  },

  // Create a new category (with optional icon)
  async createCategory(category, iconFile) {
    const formData = new FormData();
    formData.append("category", JSON.stringify(category));
    if (iconFile) {
      formData.append("icon", iconFile);
    }

    const response = await axiosInstance.post(`categories/create`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  },

  // Update existing category
  async updateCategory(id, category, iconFile) {
    const formData = new FormData();
    formData.append("category", JSON.stringify(category));
    if (iconFile) {
      formData.append("icon", iconFile);
    }

    const response = await axiosInstance.put(`categories/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  },

  // Delete a category by ID
  async deleteCategory(id) {
    const response = await axiosInstance.delete(`categories/${id}`);
    return response.data;
  },
};

export default CategoryManager;
